import React from 'react';
import { Progress } from 'antd';

const getPercentage = (prevStepCount, stepCount) =>
  prevStepCount ? ((stepCount * 100) / prevStepCount).toFixed(1) : 100;

const CompoundExecutionStepProgressDetails = ({
  stepCount,
  prevStepCount,
  totalCount,
  optional,
  style = {},
  fromDashboard,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      ...style,
    }}
  >
    <Progress
      mode="determinate"
      percent={(stepCount * 100) / totalCount || 0}
      strokeWidth={fromDashboard ? 20 : 45}
      strokeColor={optional ? '#26518c' : '#1890ff'}
      showInfo={false}
    />
    <div>
      {`${stepCount} users`}
      {prevStepCount != null ? ` (${getPercentage(prevStepCount, stepCount)}%)` : null}
    </div>
  </div>
);

export default CompoundExecutionStepProgressDetails;
